module.exports = __webpack_public_path__ + "img/FitnessFactory-01.559f0612.svg";